/// <amd-module name="Test/StackTraceParser/Common" />
import { IPageData, IVssPageService } from "VSS/Platform/Page";
import { IVssPageContext } from "VSS/Platform/Context";

export function getServiceHostUrl(pageContext: IVssPageContext): string | undefined {
    const pageService: IVssPageService = pageContext.getService<IVssPageService>("IVssPageService");
    const pageData: IPageData | undefined= pageService.getData();
    if(pageData) {
        return pageData.hostPath;
    }
}
